/**
 * The ticket the detail cache keeps (#967): never one with a lower revision
 * than the ticket it already holds. Every ticket write moves the revision by
 * one, so a lower revision is a read that started before a newer write (a
 * save, a status change, a reload) and landed after it. Taking it would turn
 * back the form and also the status, permissions and lock state the UI reads
 * from the same ticket, for example unlocking a ticket that was just
 * submitted. A ticket without a revision (a backend that predates it) is
 * taken as before.
 */
export function keepNewerTicket(current, incoming) {
    if (current &&
        incoming &&
        typeof current.revision === 'number' &&
        typeof incoming.revision === 'number' &&
        incoming.revision < current.revision) {
        return current;
    }
    return incoming;
}
//# sourceMappingURL=ticketRevision.js.map